module.exports = __webpack_public_path__ + "img/menu_upgpt_star.4a74fc7b.png";